export const zeroActivityVolume = () => ({
    visit: 0,
    call: 0,
    sms: 0,
    email: 0,
    event: 0,
    other: 0,
});
//# sourceMappingURL=marketing-plan-projection.js.map